import ClipboardJS from 'clipboard';
import 'stupid-table-plugin/stupidtable.js';
import QueryStringHandler from '../../../../../Project/Common/code/src/scripts/lib/QueryStringHandler.js';
import TruckConfiguratorSettings from './lib/TruckConfiguratorSettings.js';
import TruckConfiguratorStore from './lib/TruckConfiguratorStore.js';
import Html from './lib/HtmlHelper.js';
import HttpClient from './lib/HttpClient.js';
import ConfigurationService from './lib/ConfigurationService.js';
import LoadConfigurationForm from './lib/LoadConfigurationForm.js';
import TruckRenderLoadingScreen from './lib/TruckRenderLoadingScreen.js';
import DealerForm from './lib/DealerForm.js';
import OtcModal from './lib/modal.js';
import OtcMessage from './lib/OtcMessage.js';

var otcMain = function () {
    'use strict';

    const modal = new OtcModal();
    modal.init();

    const otcMessage = new OtcMessage('.truckconfigurator');
    otcMessage.init();

    const _this = this;

    _this._settings = new TruckConfiguratorSettings();
    _this._store = new TruckConfiguratorStore();
    _this._httpClient = new HttpClient(_this._settings.apiBaseUrl, _this._settings.antiForgeryToken, _this._settings.timeoutErrorMessage);
    _this._truckRenderLoadingScreen = new TruckRenderLoadingScreen();
    _this._dealerForm = new DealerForm(_this._httpClient, modal);
    _this._configurationService = new ConfigurationService(_this._settings, _this._httpClient, modal);
    _this._loadConfigurationForm = new LoadConfigurationForm(_this._configurationService);
    document.addEventListener('get-configuration-data-success', async (e) => {
        await _this.handleConfigurationLoaded(e);
    });
    _this.client = null;

    // Add this to prevent browser redirect to /session_terminated_index.html page which doesn't exist in Sitecore. This solution was suggested by Oliver from Kisters.
    const _AlternateLicenseErrorHandling = 2;

    // set up vars for visualisation container elements
    // so we don't have to look them up all the time
    const visContainer = document.getElementById('visualisation-container');
    const visViewer = document.getElementById('visualisationviewer'); // will contain the canvas with actual visualisation of 360 and top view
    // also create vars for the jQuery-wrapped version of elements
    // we need those when jQuery methods are like $elm.height() are called
    const $visViewer = $(visViewer);

    // insert mutation observer to re-init valtag manager on DOM manipulation
    const observer = new MutationObserver(function (mutations) {
        for (let i = 0; i < mutations.length; i++) {
            if (!mutations[i].target.classList.contains('visualisationviewer')) {
                // update valtagmanager
                if (window.digitalData) {
                    window.digitalData.update();
                }
            }
        }
    });

    // start observing
    observer.observe(document.querySelector('.truckconfigurator'), {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
        attributeFilter: ['data-dm-*'],
    });

    /**
     * initializes component
     */
    this.init = async function () {
        _this.setLoader('on', 'dark');
        _this.initHeader();
        _this.initNav();
        _this.initSidePanels();
        _this.initValidationMessage();
        _this.initSendToDealerValidationMessage();

        this.select = (el) => document.querySelector(el);
        this.selectAll = (el) => document.querySelectorAll(el);
        this.getElementById = (id) => document.getElementById(id);

        this.addClass = function (selector, className) {
            const el = _this.select(selector);
            if (!el) return;
            el.classList.add(className);
        };

        this.addClassToAll = function (selector, className) {
            const els = _this.selectAll(selector);
            if (!els || !els.length || els.length === 0) return;
            els.forEach((el) => el.classList.add(className));
        };

        this.removeClass = function (selector, className) {
            const el = _this.select(selector);
            if (!el) return;
            el.classList.remove(className);
        };

        this.removeClassFromAll = function (selector, className) {
            const els = _this.selectAll(selector);
            if (!els || !els.length || els.length === 0) return;
            els.forEach((el) => el.classList.remove(className));
        };

        this.createElement = function (el, className, text) {
            const element = document.createElement(el);
            if (className) element.className = className;
            if (text) element.innerText = text;
            return element;
        };

        var initUrl = $('.otc-previous__btn').attr('data-start-url');

        // init clipboard button(s)
        var clipboard = new ClipboardJS('.clipboard-copy');
        clipboard.on('success', function (e) {
            $(e.trigger).addClass('success');
            e.clearSelection();
        });

        var params = {};

        // populate the params object with values from query string
        this.collectQueryParams = function () {
            var qsParams = QueryStringHandler.getParams(undefined, false);
            params = {};
            if (qsParams) {
                var specs = [];
                for (const [key, value] of Object.entries(qsParams)) {
                    if (key.indexOf('-') !== -1) {
                        var keys = key.split('-');
                        if (keys[0] === 'specs') {
                            specs.push({
                                featureId: keys[1],
                                specId: keys[2],
                                specValueId: value,
                            });
                        }
                    } else {
                        params[key] = value;
                    }
                }
                if (specs.length) {
                    params['specs'] = specs;
                }
            }
        };

        this.collectQueryParams();

        this.loadPageWithQueryParams = async function () {
            this.collectQueryParams();
            var flowStepId = params.step;

            try {
                const data = await _this._httpClient.post('/createdossier', {
                    marketId: _this._settings.marketId,
                    languageId: _this._settings.languageId,
                    itemId: _this._settings.itemId,
                    flowId: params.flow,
                    specs: params.specs,
                });
                $('.otc-main').attr('data-dossier', data.Dossier.Id);
                $('.otc-main').attr('data-currencysymbol', data.Dossier.CurrencySymbol);

                // set answer order list
                if (typeof data.Flow.AnswerOrderList !== 'undefined') {
                    _this._store.answerOrderList = data.Flow.AnswerOrderList;
                }

                $('.firststep').removeClass('is-active');
                $('footer').removeClass('is-active');

                var preModelSelectionItems = data.Flow.PreModelSelectionNavigation;
                var postModelSelectionItems = data.Flow.AfterModelSelectionNavigation;

                _this.preModelSelectionItems = preModelSelectionItems;
                _this.postModelSelectionItems = postModelSelectionItems;

                var $postModelNav = $('.footer-post-model .footer-nav');
                var $premodelsectionBackNav = $postModelNav.find('.premodelsection-back-nav');

                $premodelsectionBackNav.find('li:not(.premodelsection-back-nav-template)').remove();

                var $postModelStep;
                var featuregroupName;
                var featuregroupIds;
                var featureId;
                var i;

                _this._store.featureIds = [];
                for (i = 0; i < preModelSelectionItems.length; i++) {
                    featureId = preModelSelectionItems[i].Ids[0].toLowerCase(); //Is only one id

                    _this._store.featureIds.push(featureId);
                }

                if (!_this._store.stepAmount) {
                    _this._store.stepAmount = _this._store.featureIds.length;
                }

                for (i = 0; i < postModelSelectionItems.length; i++) {
                    featuregroupName = postModelSelectionItems[i].Name;
                    featuregroupIds = postModelSelectionItems[i].Ids.join(',').toLowerCase(); //can be multiple ids.

                    var isIdAlreadyExists = $(`.footer-post-model .footer-nav li[id="${featuregroupName}"]`).length;

                    if (!isIdAlreadyExists) {
                        $postModelStep = $postModelNav.find('.footer-nav-template').clone(); //Clone the template
                        $postModelStep.removeClass('footer-nav-template');
                        $postModelStep.appendTo($postModelNav);
                        $postModelStep.prop('id', featuregroupName);
                        $postModelStep.find('a').text(featuregroupName).attr('data-featuregroups', featuregroupIds);
                    }
                }

                $('footer').addClass('is-active');

                if (data.Flow.FilterFeatureIds === null) {
                    window.location.href = window.location.origin + window.location.pathname;
                    return;
                }

                $('.premodelselectionstep-results').attr(
                    'data-filterfeatureidlist',
                    data.Flow.FilterFeatureIds.join(','),
                );

                var stepNumber = _this._store.featureIds.indexOf(flowStepId) + 1;

                if (stepNumber > 0) {
                    $('.footer-pre-model.is-active .otc-previous__btn').attr({
                        'data-previous-step': stepNumber - 1,
                        'data-featureid': _this._store.featureIds[stepNumber - 2],
                    });
                }

                if (stepNumber === _this._store.stepAmount) {
                    await _this.showResults(data.Dossier.Id);
                } else {
                    await _this.makeStep(stepNumber, data.Dossier.Id, flowStepId);
                }
            } catch (error) {
                console.error(error.message);
                if (error.userFriendlyExceptionMessage) {
                    modal.setModal(true, error.userFriendlyExceptionMessage);
                }
            }
        };

        this.loadPageWithoutQueryParams = async function () {
            try {
                const data = await _this._httpClient.get(`/getdossier?languageId=${_this._settings.languageId}&marketId=${_this._settings.marketId}&mediatype=json`);
                var dossierId = data.Id;
                $('.otc-main').attr('data-dossier', dossierId);
                $('.otc-main').attr('data-currencysymbol', data.CurrencySymbol);
                _this.setLoader('off', 'dark');
                var $firstStep = $('.firststep');
                _this.setMainTitle($('.main-title').attr('data-starttitle'));
                $firstStep.find('.block-links').addClass('is-active');
            } catch (error) {
                console.error(error.message);
                if (error.userFriendlyExceptionMessage) {
                    modal.setModal(true, error.userFriendlyExceptionMessage);
                }
            }
        };

        window.addEventListener('popstate', async () => {
            await this.handleNavigateByBrowserBackButton();
        });

        this.handleNavigateByBrowserBackButton = async function () {
            _this.cleanup();
            _this.resetVisualisationViewerSizes();
            const isStepExists = _this.checkIfStepQueryParamExists();
            if (isStepExists) {
                const turnControls = document.querySelector('.visualisation-controls .controls-turn');
                turnControls.dataset.rendered = 'no';
                await _this.loadPageWithQueryParams();
            } else {
                _this.goToInitPage();
            }
        };

        this.resetVisualisationViewerSizes = function () {
            const canvasElements = visViewer.querySelectorAll('canvas');
            for (const canvas of canvasElements) {
                canvas.width = 0;
                canvas.height = 0;
            }
        };

        this.checkIfStepQueryParamExists = function () {
            const queryParams = QueryStringHandler.getParams(undefined, false);
            if (queryParams) {
                return Object.hasOwn(queryParams, 'step');
            }
        };

        this.goToInitPage = function () {
            const isStepExists = _this.checkIfStepQueryParamExists();
            if (!isStepExists) {
                QueryStringHandler.deleteQueryParams();
            }
            if (initUrl) window.location.href = initUrl;
        };

        if (params.flow && params.step) {
            await this.loadPageWithQueryParams();
        } else if ($('#ShareKey').val().length === 0 && !$('.otc-main').attr('data-dossier')) {
            await _this.loadPageWithoutQueryParams();
        }

        let resizeTimer;
        $(window).on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                var $activeA = $('.footer-type.is-active .footer-nav li.is-active a');
                if ($activeA.length > 0) {
                    //_this.setFooterNav($activeA);
                }
            }, 500);
        });

        //Choose your path
        const flowLinks = document.querySelectorAll('.firststep .flow-link');
        const flowElement = document.getElementById('Flow');
        for (const link of flowLinks) {
            const flow = link.dataset.flow;
            link.addEventListener('click', async (e) => {
                e.preventDefault();
                flowElement.value = flow;
                await _this.createFooterNav(flow, true);
                QueryStringHandler.updateUrl(
                    QueryStringHandler.updateParams(`flow=${flow}`, QueryStringHandler.getParams(undefined, false)),
                );
            });
        }

        //Setting the answer
        $('.otc-main').on('click', '.premodelselectionstep.is-active .block-link', async function () {
            var id = $(this).attr('data-id');
            var specCharacteristicId = $(this).attr('data-spec-id');
            var $thisStep = $(this).parents('.premodelselectionstep');
            var dossierId = $('.otc-main').attr('data-dossier');
            var thisStepNumber = parseInt($(this).attr('data-step'));
            var thisFeatureId = $thisStep.attr('data-featureid');
            var nextStepNumber = parseInt(thisStepNumber) + 1;
            var nextFeatureId = _this._store.featureIds[thisStepNumber]; //Because indexes start at 0, thisStepNumber equals the index for the next step
            var setUrl =
                '/postuserchoice?dossierId=' +
                dossierId +
                '&featureId=' +
                thisFeatureId +
                '&specCharacteristicId=' +
                specCharacteristicId +
                '&specCharacteristicValueId=' +
                id +
                '&mediatype=json';
            var $prevBtn = $('.footer-pre-model.is-active .otc-previous__btn');
            _this.setLoader('on', 'dark');

            //Set the answer
            try {
                const data = await _this._httpClient.post(setUrl);
                if (data === true) {
                    _this.setLoader('off', 'dark');
                    //Set the current question to inactive
                    //$thisStep.removeClass('is-active');
                    $('.premodelselectionstep.is-active').removeClass('is-active');

                    if (thisStepNumber > 0) {
                        $prevBtn.attr({
                            'data-previous-step': thisStepNumber,
                            'data-featureid': thisFeatureId,
                        });
                    }

                    //Is there a next step? If so, show next step, otherwise show results
                    if (nextStepNumber === _this._store.stepAmount) {
                        _this.setLoader('on', 'dark');
                        await _this.showResults(dossierId);
                    } else {
                        await _this.makeStep(parseInt(thisStepNumber) + 1, dossierId, nextFeatureId);
                    }

                    var params = {};
                    params[`specs-${thisFeatureId}-${specCharacteristicId}`] = id;
                    params['step'] = nextFeatureId;

                    QueryStringHandler.updateUrl(
                        QueryStringHandler.updateParams(params, QueryStringHandler.getParams(undefined, false)),
                    );
                }
            } catch (error) {
                console.error(error.message);
                if (error.userFriendlyExceptionMessage) {
                    modal.setModal(true, error.userFriendlyExceptionMessage);
                }
            }
        });

        $('footer').on('click', '.footer-pre-model.is-active .otc-previous__btn', function () {
            var previousStep = parseInt($(this).attr('data-previous-step'));

            if (previousStep === 0) {
                _this.goToInitPage();
            } else {
                // var dossierId = $('.otc-main').attr('data-dossier');
                // var featureId = $(this).attr('data-featureid');
                var previousFeatureId = _this._store.featureIds[previousStep - 2];

                // if (previousStep === _this.stepAmount) {
                //     _this.showResults(dossierId);
                // } else {
                //     _this.makeStep(previousStep, dossierId, featureId);
                // }
                // // _this.goToPreModelStep(previousStep);
                $(this).attr({
                    'data-previous-step': previousStep - 1,
                    'data-featureid': previousFeatureId,
                });

                history.back();
            }
        });

        this.loadConfigurationDataByPremodelSelection = async function (e) {
            const selectedResultElement = e.target.closest('.otc-results__result');
            const id = selectedResultElement.dataset.id;
            _this._store.selectedCommercialSpecId = id;
            const otcMain = _this.select('.otc-main');
            const dossierId = otcMain.dataset.dossier;
            const setUrl = '/postvehicle?dossierId=' + dossierId + '&commercialSpecId=' + id;

            //Set the answer
            try {
                const data = await _this._httpClient.post(setUrl);

                if (data !== true) return;

                _this.removeClass('.main-title', 'is-active');
                _this.removeClass('.premodelselectionstep-results .mainpanel', 'is-active');
                _this.removeClass('is-active');
                _this._truckRenderLoadingScreen.show();

                //Get configuration
                const configUrl = '/getconfiguration?dossierId=' + dossierId + '&mediatype=json';

                const configData = await _this._httpClient.get(configUrl);
                _this.logMessageToKisters(`Response data is fetched and received from API after model ${configData.Vehicle.ExternalName} is selected by user. DossierId is ${configData.DossierId}.`);
                _this._store.configurationData = configData; //For later use
                _this.setModelName('on');
                await _this.initViewer();
                await _this.showConfiguration();
                QueryStringHandler.deleteQueryParams();
            } catch (error) {
                console.error(error.message);
                if (error.userFriendlyExceptionMessage) {
                    modal.setModal(true, error.userFriendlyExceptionMessage);
                }
            }

            window.digitalData.triggerVirtualPageView({
                title: _this._settings.pageViewTitle,
                name: 'Configure',
                page: 'configure',
            });
        };

        //Swipe controls in the viewer
        const swipeZone = document.getElementById('swipezone');
        swipedetect(swipeZone, function (direction) {
            const controlTurnLeft = Html.select('.visualisation-controls .control-turn-left');
            const controlTurnRight = Html.select('.visualisation-controls .control-turn-right');
            const controlTop = Html.select('.visualisation-controls .control-top');
            const controlFront = Html.select('.visualisation-controls .control-front');

            switch (direction) {
                case 'left':
                    controlTurnLeft.click();
                    break;
                case 'right':
                    controlTurnRight.click();
                    break;
                case 'up':
                    controlTop.click();
                    break;
                case 'down':
                    controlFront.click();
                    break;
                default:
                    return;
            }
        });

        //Go to postmodel selection on detail page
        $('body').on('click', '.detail-main .btn-configure', async function () {
            await _this.showConfiguration();
        });

        //Contact dealer on detail page
        $('body').on('click', '.detail-main .btn-contactdealer', function () {
            $('.header-send a').trigger('click');
        });

        //Save & share modal window logic
        document.querySelectorAll('.modal-save .label').forEach((tab) => {
            tab.addEventListener('click', (event) => this.tabHandler(event));
        });

        var clientId = null;
        var serverHostname;

        var client = new VSWebClient();
        _this.client = client;

        client.initialize(visViewer, _this._settings.truckRenderWebsocketUrl, {
            canvasMode: 'image',
            blockOnLoad: true,
            skipVSLogo: true,
            preventRetry: false,
            emitXMLResponsesUnparsed: true,
            routeOnRetriedAuthenticationFail: true,
        });

        client.once('SessionInfo', async (e) => {
            serverHostname = e.ServerHostname;
            clientId = e.ClientId;
            const url = '/gettoken?clientId=' + clientId + '&serverHostname=' + serverHostname + '&mediatype=json';

            try {
                const data = await _this._httpClient.get(url);
                const authenticationRequest =
                    '<Request Type="AuthenticateSession"><Token>' + data + '</Token></Request>';
                client.command.executeXML(authenticationRequest);
            } catch (error) {
                console.error(error.message);
                if (error.userFriendlyExceptionMessage) {
                    modal.setModal(true, error.userFriendlyExceptionMessage);
                }
            }
        });

        // //Don't put on another location, it matters
        _this.manageKistersConnection();

        client.on('GetImage', function (e) {
            var imageUrl = 'data:image/png;base64, ' + e.Image;
            $('.summary .summary-truck-image').attr('src', imageUrl);
            $('.summary-truck-image-wrapper').addClass('is-active');
        });

        client.on('initialized', function () {
            client.command.executeXML('<Call Method="RefreshScene"></Call>');
            _this.logMessageToKisters('Client initialized.');
        });

        client.on('SessionAuthenticated', function () {
            //Nothing needed here
            _this.logMessageToKisters('Client session authenticated.');
        });

        client.on('SessionReady', function () {
            _this.logMessageToKisters('Client session ready.');
            // If user uses share key, to prevent timing issues:
            // wait until the session is ready before getting configuration

            var shareKey = $('#ShareKey').val();
            if (shareKey) {
                $('.footer-post-model').addClass('is-active'); // For speed this is done here and now
                _this._configurationService.getConfigurationByShareKey(shareKey);
            }

            var newScene3DRequest = '<Call Method="NewScene3D"></Call>';
            _this.client.command.executeXML(newScene3DRequest);
        });

        client.on('UpdateScene', function () {
            if ($('.visualisation-controls .controls-turn').attr('data-rendered') == 'no') {
                $('.visualisation-controls .controls-turn').attr('data-rendered', 'yes');

                //Render for the first time
                var hAngle = $('.visualisation-controls .controls-turn').attr('data-rotation');
                var alignment = $('.visualisation-controls .controls-turn').attr('data-alignment');

                modal.setModal(false);
                _this.client.resize($visViewer.width(), $visViewer.height());

                const date = new Date();
                const timestamp = date.toISOString();
                const logMessage = 'Client log from UpdateScene event at: ' + timestamp;

                const xml =
                    '<Call Method="SetRenderMode"><RenderMode>Solid</RenderMode><RenderMode>Material</RenderMode><RenderMode>Perspective</RenderMode><RenderMode>Shadow</RenderMode></Call>' +
                    '<Call Method="SetSceneSettings" CustomId="set_background"><Settings><Scene><Visualization><Background><BackgroundColorTop>#F1F1F1</BackgroundColorTop></Background></Visualization></Scene></Settings></Call>' +
                    `<Call Method="SetSceneSettings" CustomId="set_camera"><Settings><Scene><Rendering><ShowAxis>false</ShowAxis></Rendering><Alignment><HAngle>${hAngle}</HAngle><VAngle>1</VAngle><UpVector>Z</UpVector></Alignment></Scene></Settings></Call>` +
                    `<Call Method="AlignView"><Alignment>${alignment}</Alignment></Call>` +
                    '<Call Method="ResetZoom"></Call>' +
                    `<Call Method="LogMessage"><Message>${logMessage}</Message><Level>Info</Level></Call>`;

                _this.client.command.executeXML(xml);

                setTimeout(function () {
                    _this._truckRenderLoadingScreen.hide();
                    $visViewer.addClass('is-visible');
                    $('.visualisation-controls').addClass('is-active');
                    $('.btn-configure').removeClass('is-inactive');
                    _this.setSwipezone('on');
                    _this.setModelName('on');
                }, 800);
            } else {
                //Update only
                $('.postmodelselection .sideloader').removeClass('is-active');
                $('.postmodelselection .sub-item-option-panel-disabler').removeClass('is-active');
            }
        });
    };

    this.logMessageToKisters = function(message) {
        const date = new Date();
        const timestamp = date.toISOString();
        const xml = `<Call Method="LogMessage"><Message>${message} Timestamp: ${timestamp}.</Message><Level>Info</Level></Call>`;
        _this.client.command.executeXML(xml);
    };

    this.wrapEvent = function (obj, oneventName, handler) {
        var currentEventHandler = obj[oneventName];
        if (currentEventHandler) {
            obj[oneventName] = function (e) {
                currentEventHandler(e);
                handler(e);
            };
        } else {
            obj[oneventName] = handler;
        }
    };

    this.isKistersConnected = function () {
        return _this.client.sessionInfo.socket.readyState === _this.client.sessionInfo.socket.OPEN;
    };

    // Only one can watch the onclose and onmessage events of the client. So wrap the original events.
    this.manageKistersConnection = function () {
        _this.wrapEvent(_this.client.sessionInfo.socket, 'onclose', function () {
            $('.visualisation-controls .controls-turn').attr('data-rendered', 'no');

            window.setTimeout(function () {
                if (!_this.isKistersConnected()) {
                    _this.client.initialize(visViewer, _this._settings.truckRenderWebsocketUrl, {
                        canvasMode: 'image',
                        blockOnLoad: true,
                        skipVSLogo: true,
                        preventRetry: true,
                        emitXMLResponsesUnparsed: !0,
                        routeOnRetriedAuthenticationFail: true,
                    });
                    _this.manageKistersConnection();

                    _this.client.once('NewScene3D', async function () {
                        await _this.onInitializedViewer(_this.client);
                    });
                }
            }, 500);
        });

        _this.wrapEvent(_this.client.sessionInfo.socket, 'onmessage', function () {
            clearInterval(_this._store.fallbackInterval);
        });
    };

    this.initSidePanels = function () {
        $('.otc-main').on('click', '.icon-close', function () {
            if ($('.sidepanels').hasClass('is-visible')) {
                $('.sidepanels').removeClass('is-visible');
                _this.setVisualisationControls(false);
                _this.setSwipezone('on');
            }
        });

        //Main categories (including accordion)
        $('.otc-main').on('click', '.sidepanels .sidepanel-main > li > a', function () {
            var $li = $(this).parent();
            $('.sidepanels').addClass('is-visible');
            $li.toggleClass('is-active');
            // var $sidepanelSub = $li.find('.sidepanel-sub');
        });

        //Sub categories
        $('.otc-main').on('click', '.sidepanels .sidepanel-sub > li > a', function () {
            var $li = $(this).parent();
            var open = true;
            if ($li.hasClass('is-active')) {
                open = false;
            }
            $('.sidepanels .sidepanel-sub > li').removeClass('is-active');

            if (open === true) {
                $li.addClass('is-active');
            } else {
                $li.removeClass('is-active');
            }

            if ($('.sidepanels .sidepanel-sub > li.is-active').length > 0) {
                $('.sidepanel-main').addClass('has-open-subpanel');
            } else {
                $('.sidepanel-main').removeClass('has-open-subpanel');
            }
        });

        //Sub categories close
        $('.otc-main').on('click', '.sidepanels .sub-item-option-panel .icon-close', function () {
            $(this).parents('li').eq(0).find('a').eq(0).trigger('click');
        });

        //Sub category items - selection (Option selection)
        $('.otc-main').on(
            'click',
            '.sidepanels .sidepanel-sub:not(.sidepanel-sub-colorpicker) .option-item',
            async function () {
                var $li = $(this).parents('li').eq(0);

                // do nothing if clicked on selected option
                if ($li.hasClass('is-selected')) return;

                // var $optionInfoButton = $li.find('.option-more-info-btn');
                var $siblings = $li.siblings();
                var currentSelectedOptionId = $siblings.filter('.is-selected').attr('data-optionid');
                // var h = $des.attr('data-height');//Because we can't animate between heigh 0 and auto

                $('.modal-validation').attr('data-previous-optionid', currentSelectedOptionId);
                $siblings.removeClass('is-selected');
                $li.addClass('is-selected');

                if ($('.postmodelselection').hasClass('is-active')) {
                    var dossierId = $('.otc-main').attr('data-dossier');
                    var featureId = $(this).attr('data-featureid');
                    var optionId = $(this).attr('data-optionid');
                    var setUrl =
                        '/postconfigurationoption?dossierId=' +
                        dossierId +
                        '&featureId=' +
                        featureId +
                        '&optionId=' +
                        optionId +
                        '&mediatype=json';
                    _this.logMessageToKisters(`User selected configuration option. OptionId: ${optionId}. FeatureId: ${featureId}. DossierId: ${dossierId}.`);
                    $('.postmodelselection .sideloader').addClass('is-active');
                    $('.postmodelselection .sub-item-option-panel-disabler').addClass('is-active');

                    $('.modal-validation').attr('data-selected-optionid', optionId);

                    try {
                        //Set the answer
                        const data = await _this._httpClient.post(setUrl);
                        _this._store.configurationData = data;
                        _this.logMessageToKisters(`Selected configuration option is posted to API. OptionId: ${optionId}. FeatureId: ${featureId}. DossierId: ${dossierId}.`);
                        _this.recheckPostModelSelectionOptions();
                    }  catch (error) {
                        console.error(error.message);
                        if (error.userFriendlyExceptionMessage) {
                            modal.setModal(true, error.userFriendlyExceptionMessage);
                        }
                    }
                }
            },
        );
    };

    this.getSubItemPanelHeight = function (section) {
        var $section = $('.' + section);

        var sidePanelHeight = $section.find('.sidepanels').height();

        var mainItemsHeight = 0;
        $section.find('.sidepanels .sidepanel-main > li').each(function () {
            mainItemsHeight = mainItemsHeight + $(this).outerHeight(true);
        });
        var subItemPanelHeight = sidePanelHeight - mainItemsHeight;
        return subItemPanelHeight;
    };

    this.setSidePanelHeight = function (section) {
        var $section = $('.' + section);
        // var h = 0;
        $section.find('.sidepanels .sidepanel-main > li .sidepanel-sub').each(function (index) {
            //Index = 1 is first one after template
            if (index === 1) {
                $(this).parents('li').addClass('is-active');
            }
        });
    };

    this.initHeader = function () {
        const saveBtn = Html.select('.header-save a');
        saveBtn?.addEventListener('click', async () => {
            await _this.setSaveInfo();
        });
    };

    this.setSaveInfo = async function () {
        const dossierId = Html.select('.otc-main')?.dataset.dossier;
        const url = '/getsharekeyasync?dossierId=' + dossierId + '&mediatype=json';

        try {
            const shareKey = await _this._httpClient.get(url);

            const saveModalShareKeyElement = Html.select('.modal-save .modal-code');
            saveModalShareKeyElement.innerText = shareKey;

            const shareKeyInputElement = Html.getById('ShareKey');
            shareKeyInputElement.value = shareKey;

            modal.setModal(true, false, 'save');
        } catch (error) {
            console.error(error.message);
            if (error.userFriendlyExceptionMessage) {
                modal.setModal(true, error.userFriendlyExceptionMessage);
            }
        }
    };

    this.tabHandler = (event) => {
        const activeTab = event.currentTarget;
        const tabsContainer = activeTab.closest('.labels');
        const tabs = tabsContainer.querySelectorAll('.label');

        tabs.forEach((tab) => {
            tab.classList.toggle('is-active', tab === activeTab);
        });
    };

    this.validationModal = function () {
        var $selected = $('.modal-validation-selected');
        var selected = _this._store.configurationData?.Validation.Selected;
        var $deselected = $('.modal-validation-deselected');
        var deselected = _this._store.configurationData?.Validation.Deselected;

        $selected.empty();
        $deselected.empty();

        if (selected.length > 1 && deselected.length > 1 && !$('.modal-validation').hasClass('is-canceled')) {
            $('.validation-option-title').text(
                $(
                    '.sidepanel-main .sub-item-options li[data-optionid="' +
                        $('.modal-validation').attr('data-selected-optionid') +
                        '"] .option-title-text',
                ).text(),
            );

            for (var s = 0; s < selected.length; s++) {
                $selected.append('<li>' + selected[s].Description + '</li>');
            }

            for (var d = 0; d < deselected.length; d++) {
                $deselected.append('<li>' + deselected[d].Description + '</li>');
            }

            modal.setModal(true, false, 'validation');

            _this.updateModalContentToggle(document.querySelector('.modal-validation'));
        }

        $('.modal-validation').removeClass('is-canceled');
    };

    this.updateModalContentToggle = (modal) => {
        const modalContent = modal.getElementsByClassName('modal-content-wrapper')[0];
        const hasVerticalScrollbar = modalContent.scrollHeight > modalContent.clientHeight;
        modal.getElementsByClassName('icon--chevron-down')[0].classList.toggle('hidden', !hasVerticalScrollbar);
    };

    this.recheckPostModelSelectionOptions = function () {
        //Because a selection is made, some items may be come incompatible.... this function checks that and sets everything correctly
        _this.validationModal();

        var featuregroups = _this._store.configurationData?.FeatureGroups;
        var gMax = featuregroups.length - 1;
        var fMax;
        var oMax;

        for (var g = 0; g < featuregroups.length; g++) {
            var features = featuregroups[g].Features;
            if (g == gMax) fMax = features.length - 1;
            for (var f = 0; f < features.length; f++) {
                var options = features[f].Options;
                if (g == gMax && f == fMax) oMax = options.length - 1;
                for (var o = 0; o < options.length; o++) {
                    var $option = $(
                        '.postmodelselection .sidepanels .sub-item-options li[data-optionid="' + options[o].Id + '"]',
                    );

                    if (options[o].IsIncompatible === true) {
                        $option.addClass('is-incompatible');
                    } else {
                        $option.removeClass('is-incompatible');
                    }

                    if (options[o].IsSelected === true) {
                        $option.addClass('is-selected');
                    } else {
                        $option.removeClass('is-selected');
                    }

                    if (g == gMax && f == fMax && o == oMax) {
                        //The final step in this loop, so turn the loader off (NEW: done in updatescene)
                    }
                }
            }
        }
    };

    this.getFileExtension = function (filename) {
        return filename.substr(filename.lastIndexOf('.') + 1);
    };

    this.setLoader = function (setting, optionalClass) {
        if (setting == 'on') {
            if (optionalClass !== '') $('.loader').addClass(optionalClass);
            $('.otc-main .main-title').removeClass('is-active');
            $('.loader').addClass('is-active');
            $('footer').addClass('is-disabled');
        }
        if (setting == 'off') {
            $('.loader').removeClass('is-active');
            $('footer').removeClass('is-disabled');
            if (optionalClass !== '') $('.loader').removeClass(optionalClass);
        }
    };

    this.setMainTitle = function (titleText) {
        var $title = $('.otc-main .main-title');
        $title.removeClass('is-active');
        if (titleText === undefined) {
            setTimeout(function () {
                $title.text('&nbsp;');
            }, 350);
        } else {
            setTimeout(function () {
                $title.text(titleText);
            }, 350);
            setTimeout(function () {
                $title.addClass('is-active');
            }, 400);
        }
    };

    /**
     * Show the results
     */
    this.showResults = async function (dossierId) {
        const resultUrl = '/getmodellist?dossierId=' + dossierId + '&mediatype=json';
        const resultsTable = _this.select('.premodelselectionstep-results .otc-results');

        _this.removeClass('.otc-main .main-title', 'is-active');

        let data;

        try {
            data = await _this._httpClient.get(resultUrl);
        } catch (error) {
            console.error(error.message);
            if (error.userFriendlyExceptionMessage) {
                modal.setModal(true, error.userFriendlyExceptionMessage);
            }
        }

        _this.setLoader('off', 'dark');

        const premodelselectionstepResults = _this.select('.premodelselectionstep-results');

        if (!premodelselectionstepResults) return;

        premodelselectionstepResults.classList.add('is-active');

        //Small timeout for animation events. The display none prohibits this otherwise
        setTimeout(function () {
            _this.addClass('.mainpanel', 'is-active');
        }, 400);

        //Clear the table if it was filled before
        if (resultsTable.innerHTML.length > 0) resultsTable.innerHTML = '';

        if (!data.Models || data.Models.length === 0 || !data.Characteristics || data.Characteristics.length === 0)
            return _this.addClass('.results-noresults', 'is-active');

        _this.removeClass('.results-noresults', 'is-active');

        let modelsWithoutImage = 0;
        let modelAmount = 0;

        function spec(description, val) {
            const result = _this.createElement('LI');
            const value = _this.createElement('SPAN', 'otc-results__result-spec', val);
            result.innerText = description;
            result.dataset.value = val;
            result.appendChild(value);
            return result;
        }

        function model(model) {
            const modelClassList =
                modelAmount % 2 == 0
                    ? 'otc-results__result col-12 col-md-5'
                    : 'otc-results__result col-12 col-md-5 offset-md-1';

            const result = _this.createElement('DIV', modelClassList);
            result.dataset.configuratorAction = 'result';
            result.dataset.id = model.Id;
            result.dataset.dossier = dossierId;
            result.dataset.model = model.Name;
            result.addEventListener('click', (e) => {
                _this.logMessageToKisters(`User selected model with id: ${model.Id}, name ${model.Name} and dossierId ${dossierId}`);
                _this.loadConfigurationDataByPremodelSelection(e);
            });

            const titleText = model.Description !== '' ? `${model.Name} ${model.Description}` : model.Name;
            const title = _this.createElement('H2', 'otc-results__result-title', titleText);
            result.appendChild(title);

            const imgContainer = _this.createElement('DIV', 'otc-results__visual-wrapper');
            const img = _this.createElement('IMG', 'otc-results__result-image');
            img.src = model.ImageUrl;
            img.alt = model.Name;

            imgContainer.appendChild(img);
            result.appendChild(imgContainer);

            if (model.CharacteristicValues && model.CharacteristicValues.length > 0) {
                const specsList = _this.createElement('UL', 'otc-results__result-specs');

                model.CharacteristicValues.forEach((value, i) => {
                    specsList.appendChild(spec(data.Characteristics[i].Description, value));
                });

                result.appendChild(specsList);
            }

            return result;
        }

        for (const mdl of data.Models) {
            if (mdl.ImageUrl === null) {
                modelsWithoutImage++;
            } else {
                resultsTable.appendChild(model(mdl));
                modelAmount++;
            }
        }

        if (modelsWithoutImage > 0) {
            _this.addClass('.premodelselectionstep .results-message', 'is-active');
        } else {
            _this.removeClass('.premodelselectionstep .results-message', 'is-active');
        }

        _this.initBreadcrumb(data.BreadCrumb);

        window.digitalData.triggerVirtualPageView({
            title: _this._settings.pageViewTitle,
            name: 'Results',
            page: 'results',
        });
    };

    this.initBreadcrumb = (breadcrumbs) => {
        const $header = document.getElementById('breadcrumb');
        const initUrl = document.querySelector('.otc-previous__btn').getAttribute('data-start-url');
        const flow = document.getElementById('Flow').getAttribute('value');

        $header.innerHTML = '';

        for (const [title, breadcrumbParameters] of Object.entries(breadcrumbs)) {
            if (breadcrumbParameters) {
                let url;

                if (initUrl.includes('?')) {
                    url = `${initUrl}&flow=${flow}${breadcrumbParameters}`;
                } else {
                    url = `${initUrl}?flow=${flow}${breadcrumbParameters}`;
                }
                $header.innerHTML += `<a class="breadcrumb-nav__item breadcrumb-nav__link" href="${url}">${title}</a>`;
            } else {
                //This is just the current page so not clickable
                $header.innerHTML += `<span class="breadcrumb-nav__item breadcrumb-nav__title">${title}</span>`;
            }
        }
    };

    /**
     * Show a premodel step
     */
    this.makeStep = async function (stepNumber, dossierId, featureId) {
        _this.cleanup();

        //First destroy the step if it's already there as i needs to be build again with the correct data
        if ($('.premodelselectionstep-' + featureId).length > 0) {
            $('.premodelselectionstep-' + featureId).remove();
        }

        _this.setLoader('on', 'dark');
        const url =
            '/getquestionlist?dossierId=' +
            dossierId +
            '&featureIdlist=' +
            featureId +
            '&mediatype=json&answerOrderList=' +
            _this._store.answerOrderList;

        try {
            const data = await _this._httpClient.get(url);
            //JSON info
            var titleText = data.Questions[0].Description;
            var answers = data.Questions[0].Answers;
            var specCharacteristicId = data.Questions[0].SpecCharacteristicId;

            _this.setLoader('off', 'dark');

            //The HTML part
            var $mainwrapper = $('.otc-main');
            var $stepTemplate = $('.premodelselectionstep-template'); //Get the main step template
            var $thisStep = $stepTemplate.clone(); //Clone the template
            $thisStep
                .removeClass('premodelselectionstep-template')
                .addClass('is-active')
                .addClass('premodelselectionstep-' + featureId)
                .addClass('step-' + stepNumber)
                .attr('data-step', stepNumber)
                .attr('data-dossier', dossierId)
                .attr('data-featureid', featureId)
                .attr('data-titletext', titleText); //Copy the template, and activate it
            $thisStep.appendTo($mainwrapper); //Place the step on the page
            var $list = $thisStep.find('.block-links'); //The list we're going to fill
            var $itemTemplate = $list.find('.col-md-3'); //The item template
            $itemTemplate.remove(); //Remove the actual item template element
            var numberOfAnswers = answers.length;
            var actualNumberOfAnswers = 0;

            var $newItem;
            for (var i = 0; i < numberOfAnswers; i++) {
                $newItem = $itemTemplate.clone();
                if (answers[i].ImageUrl === null) continue;
                if (answers[i].IsIncompatible === true) continue;

                actualNumberOfAnswers++;

                $newItem
                    .find('.block-link')
                    .attr('title', answers[i].Description)
                    .attr('data-id', answers[i].Id)
                    .attr('data-spec-id', specCharacteristicId)
                    .attr('data-step', stepNumber);
                $newItem.find('.block-link-visual').attr('src', answers[i].ImageUrl);
                $newItem.find('.block-link-title').text(answers[i].Description);
                // $newItem.find('.btn').text(answers[i].ButtonText);
                if (stepNumber === 1) {
                    $newItem.removeClass('col-12 col-sm-6');
                    $newItem.addClass('col-6');
                }

                // if (answers[i].IsSelected === true) $newItem.find('.block-link').addClass('is-active');
                if (answers[i].IsIncompatible === true) $newItem.addClass('is-incompatible');

                $newItem.appendTo($list);
            }

            if (actualNumberOfAnswers === 2) {
                var lineBreak = '<div class="w-100 block-link-line-break"></div>';
                $list.addClass('justify-content-center');
                $list.children().eq(1).before(lineBreak);
            }

            //Set the title width of each title to the max width of the image
            var $blockTitles = $thisStep.find('.block-link-title');
            var titleWidth = $thisStep.find('.block-link-visual').eq(0).width();
            var w;
            $blockTitles.each(function () {
                w = $(this).width();
                if (w < titleWidth) {
                    titleWidth = w;
                }
            });
            setTimeout(function () {
                $list.addClass('is-active');
            }, 400);

            _this.setMainTitle(titleText);
            //_this.setFooterNav($('.footer-pre-model .footer-nav .nav-feature-' + featureId + ' a'));

            _this.initBreadcrumb(data.BreadCrumb);
        } catch(error) {
            console.error(error.message);
            if (error.userFriendlyExceptionMessage) {
                modal.setModal(true, error.userFriendlyExceptionMessage);
            }
        }

        var flow = $('#Flow').val();
        // virtual pageview
        if (flow && stepNumber) {
            var readableStep = this.getReadableFlowStep(flow, stepNumber);

            if (readableStep) {
                window.digitalData.triggerVirtualPageView({
                    title: _this._settings.pageViewTitle,
                    name: readableStep,
                    page: readableStep.replace(' ', '').toLowerCase(),
                });
            }
        }
    };

    this.getReadableFlowStep = function (flow, step) {
        var FlowSteps = {
            product: {
                1: 'Discover',
                2: 'Chassis Type',
            },
            application: {
                1: 'Assist',
                3: 'Chassis Type',
            },
        };

        return FlowSteps[flow] && FlowSteps[flow][step];
    };

    this.setSwipezone = function (state) {
        if (state == 'on') {
            $('.swipezone').addClass('is-active');
        }
        if (state == 'off') {
            $('.swipezone').removeClass('is-active');
        }
    };

    this.setModelName = function (state) {
        if (state == 'on') {
            $('.model-name-container .model-name').text(_this._store.configurationData?.Vehicle.ExternalName);
            $('.model-name-container').addClass('is-active');
        }
        if (state == 'off') {
            $('.model-name-container').removeClass('is-active');
        }
    };

    this.initNav = function () {
        //This sets the interaction and some basic navigation. The content of footer nav is set up in createFooterNav as it's dynamic

        //Default nav click
        $('body').on('click', '.footer-nav > li > a', function (e) {
            var $li = $(this).parent();

            if ($li.hasClass('is-disabled')) {
                e.preventDefault();
                return false;
            }

            //STYLING PART
            if (!$li.hasClass('footer-home')) {
                _this.setFooterNav($(this));
            }

            //Post model
            if ($('.footer-post-model').hasClass('is-active')) {
                if ($li.hasClass('footer-home')) {
                    modal.setModal(true, false, 'home');

                    const modalContent = document.querySelector('.modal-home .modal-content-wrapper');
                    const hasVerticalScrollbar = modalContent.scrollHeight > modalContent.clientHeight;
                    document
                        .querySelector('.modal-home .icon--chevron-down')
                        .classList.toggle('hidden', !hasVerticalScrollbar);

                    return;
                }
                var featureGroupsAttr = $(this).attr('data-featuregroups');
                var featuregroups = featureGroupsAttr ? String(featureGroupsAttr).split(',') : [];

                $('.postmodelselection .sidepanels .sidepanel-main > li').removeClass('is-visible');
                $('.sidepanels').removeClass('is-visible');

                $('.sidepanel-header > h2').text(e.target.innerText);

                $('.postmodelselection .sidepanels .sidepanel-main > li').removeClass('is-visible');
                $('.sidepanels').removeClass('is-visible');

                $('.sidepanel-header > h2').text(e.target.innerText);

                for (var f = 0; f < featuregroups.length; f++) {
                    $('.sidepanels').addClass('is-visible');
                    $(
                        '.postmodelselection .sidepanels .sidepanel-main > li[data-featuregroup="' +
                            featuregroups[f] +
                            '"]',
                    ).addClass('is-visible');
                }

                if (featuregroups == 'colorpicker') {
                    $('.sidepanel-sub-item-colorpicker').addClass('is-visible');
                }
            }
        });

        //Summary
        $('header .button-summary').on('click', function () {
            $('.visualisation-controls').toggleClass('is-outofsight');
            $('.summary').toggleClass('is-active');

            if ($('.summary').hasClass('is-active')) {
                _this.makeSummary();

                window.digitalData.triggerVirtualPageView({
                    title: _this._settings.pageViewTitle,
                    name: 'Vehicle summary',
                    page: 'vehiclesummary',
                });
            }

            $('.main-overlay').toggleClass('is-active', $('.summary').hasClass('is-active'));
        });

        const summaryPrintBtn = document.querySelector('.summary .btn-print');
        if (summaryPrintBtn) {
            summaryPrintBtn.addEventListener('click', function () {
                _this.printSummary();
                window.print();
            });
        }

        $('.summary .close-summary').on('click', function () {
            $('.visualisation-controls').toggleClass('is-outofsight');
            $('.summary').removeClass('is-active');

            if ($('.summary').hasClass('is-active')) {
                _this.makeSummary();

                window.digitalData.triggerVirtualPageView({
                    title: _this._settings.pageViewTitle,
                    name: 'Vehicle summary',
                    page: 'vehiclesummary',
                });
            }
        });

        //New logic for the modal of the Home button
        $('body').on('click', '.modal-home .modal-btn-restart', function () {
            window.location.href = location.protocol + '//' + location.host + location.pathname;
        });

        $('body').on('click', '.modal-home .modal-btn-stay', function () {
            $('.modal-home .modal-close').trigger('click');
        });
    };

    this.createFooterNav = async function (flow, goToFirstStep) {
        var dossierId = $('.otc-main').attr('data-dossier');

        //When the code is filled in directly (not using a link), we don't know the premodel route, so we choose product
        if (flow.length === 0 || flow == 'load') flow = 'product';

        const url =
            '/postinitializeflow?itemId=' +
            _this._settings.itemId +
            '&dossierId=' +
            dossierId +
            '&flow=' +
            flow +
            '&mediatype=json';
        //var data = _this.configurationData;

        $('.firststep .block-links').removeClass('is-active');

        try {
            const data = await _this._httpClient.post(url);
            // set answer order list
            if (typeof data.AnswerOrderList !== 'undefined') {
                _this._store.answerOrderList = data.AnswerOrderList;
            }

            $('.firststep').removeClass('is-active');
            $('footer').removeClass('is-active');

            var preModelSelectionItems = data.PreModelSelectionNavigation;
            var postModelSelectionItems = data.AfterModelSelectionNavigation;

            _this.preModelSelectionItems = preModelSelectionItems;
            _this.postModelSelectionItems = postModelSelectionItems;

            // var $preModelNav = $('.footer-pre-model .footer-nav');
            var $postModelNav = $('.footer-post-model .footer-nav');

            var $premodelsectionBackNav = $postModelNav.find('.premodelsection-back-nav');
            // var $premodelsectionBackNavTemplate = $postModelNav.find('.premodelsection-back-nav-template');

            $premodelsectionBackNav.find('li:not(.premodelsection-back-nav-template)').remove();

            // var $preModelStep;
            var $postModelStep;
            // var $newBackNav;
            //var navName;
            var featuregroupName;
            var featuregroupIds;
            // var featureName;
            var featureId;
            var i;

            for (i = 0; i < preModelSelectionItems.length; i++) {
                // featureName = preModelSelectionItems[i].Name;
                featureId = preModelSelectionItems[i].Ids[0].toLowerCase(); //Is only one id

                _this._store.featureIds.push(featureId);
            }

            _this._store.stepAmount = _this._store.featureIds.length;

            // $('.footer-pre-model .footer-nav > li').css('width', (100 / _this.stepAmount) + '%');

            for (i = 0; i < postModelSelectionItems.length; i++) {
                featuregroupName = postModelSelectionItems[i].Name;
                featuregroupIds = postModelSelectionItems[i].Ids.join(',').toLowerCase(); //can be multiple ids.

                var isIdAlreadyExists = $(`.footer-post-model .footer-nav li[id="${featuregroupName}"]`).length;

                if (!isIdAlreadyExists) {
                    $postModelStep = $postModelNav.find('.footer-nav-template').clone(); //Clone the template
                    $postModelStep.removeClass('footer-nav-template');
                    $postModelStep.appendTo($postModelNav);
                    $postModelStep.prop('id', featuregroupName);
                    $postModelStep.find('a').text(featuregroupName).attr('data-featuregroups', featuregroupIds);
                }
            }

            $('footer').addClass('is-active');

            $('.premodelselectionstep-results').attr('data-filterfeatureidlist', data.FilterFeatureIds.join(','));

            if (goToFirstStep === true) {
                //We start with the first featureId
                _this.makeStep(1, $('.otc-main').attr('data-dossier'), data.PreModelSelectionNavigation[0].Ids[0]);
                QueryStringHandler.updateUrl(
                    QueryStringHandler.updateParams(
                        `step=${data.PreModelSelectionNavigation[0].Ids[0]}`,
                        QueryStringHandler.getParams(undefined, false),
                    ),
                );
            }
        } catch (error) {
            console.error(error.message);
            if (error.userFriendlyExceptionMessage) {
                modal.setModal(true, error.userFriendlyExceptionMessage);
            }
        }
    };

    this.summarizeTo = function (element) {
        function optionItem(titleText, id) {
            const result = _this.createElement('LI', 'summary-item');
            const title = _this.createElement('SPAN', 'summary-item-title', titleText);
            const itemId = _this.createElement('SPAN', 'summary-item-id', id);

            result.appendChild(title);
            result.appendChild(itemId);

            return result;
        }

        function setFeatures(featureGroupId, featureGroupItem) {
            const featureGroup = _this._store.configurationData?.FeatureGroups.find((fg) => fg.Id === Number(featureGroupId));

            if (!featureGroup || !featureGroup.Features || featureGroup.Features.length === 0) return;

            for (const feature of featureGroup.Features) {
                if (feature.Options && feature.Options.length > 0) {
                    for (const option of feature.Options) {
                        if (!option.IsSelected) continue;
                        featureGroupItem.appendChild(optionItem(option.Description, option.Id));
                    }
                }
            }
        }

        function featureGroupItem(featureGroupId) {
            const result = _this.createElement(
                'UL',
                `summary-featuregroup-item summary-featuregroup-${featureGroupId}`,
            );
            setFeatures(featureGroupId, result);
            return result;
        }

        function summaryCategory(titleText, featuregroupIdList) {
            const result = _this.createElement('DIV', 'summary-category');
            const title = _this.createElement('H4', 'summary-category-title', titleText);
            const featureGroupItems = _this.createElement('DIV', 'summary-featuregroup-items');

            for (const featureGroupId of featuregroupIdList) {
                featureGroupItems.appendChild(featureGroupItem(featureGroupId));
            }

            result.appendChild(title);
            result.appendChild(featureGroupItems);

            return result;
        }

        for (const item of _this.postModelSelectionItems) {
            element.appendChild(summaryCategory(item.Name, item.Ids));
        }
    };

    this.printSummary = function () {
        let printContent;

        function initPrintContainer() {
            const print = _this.select('.print-only');
            if (!print) {
                const printContainer = _this.createElement('DIV', 'print-only');
                printContent = _this.createElement('DIV', 'summary-inner');
                printContainer.appendChild(printContent);
                const body = _this.select('body');
                body.insertAdjacentElement('afterbegin', printContainer);
            } else {
                printContent = _this.select('.summary-inner');
                printContent.innerHTML = '';
            }
        }

        function populateContent() {
            const titlePrefix = _this.createElement(
                'H2',
                'summary-inner__title',
                _this.select('.summary-inner__title').dataset.prefixtext + ' ',
            );
            const modelName = _this.createElement(
                'SPAN',
                'summary-truck-title',
                _this._store.configurationData?.Vehicle.ExternalName,
            );
            titlePrefix.appendChild(modelName);
            printContent.appendChild(titlePrefix);
            _this.summarizeTo(printContent);
        }

        initPrintContainer();
        populateContent();
    };

    this.makeSummary = function () {
        const summaryContent = _this.select('.summary-content');

        if (!summaryContent) return;

        summaryContent.innerHTML = '';

        const title = _this.select('.modal-summary .summary-truck-title');

        if (title) title.innerText = _this._store.configurationData?.Vehicle.ExternalName;

        _this.summarizeTo(summaryContent);
    };

    this.initColorPicker = async function (sidePanels, sidePanelMain, colourName) {
        const dossierId = _this.select('.otc-main').dataset.dossier;

        async function setColor(url) {
            try {
                await _this._httpClient.post(url);
            } catch (error) {
                console.error(error.message);
                if (error.userFriendlyExceptionMessage) {
                    modal.setModal(true, error.userFriendlyExceptionMessage);
                }
            }
            // UpdateScene is called
        }

        async function handleColorOptionSelected(e) {
            const colorOption = e.target.closest('.color-option');
            const parent = colorOption.parentElement;
            const featureId = colorOption.dataset.featureid;
            const colourId = colorOption.dataset.colourid;
            const description = encodeURI(colorOption.dataset.description);
            const userSpecifiedDescription = '';
            const hexCode = colorOption.dataset.hexcode;
            const colourOptionId = colorOption.dataset.colouroptionid;
            const colourNatureType = colorOption.dataset.colournaturetype;

            _this.logMessageToKisters(`Color option selected. ColorId: ${colourId}. Description: ${colorOption.dataset.description}. HexCode: ${hexCode}. ColorOptionId: ${colourOptionId}. ColourNatureType: ${colourNatureType}.`);
            _this.removeClassFromAll('.sidepanel-sub-colorpicker .sub-item-options li', 'is-selected');
            parent.classList.add('is-selected');
            _this.addClass('.postmodelselection .sideloader', 'is-active');
            _this.addClassToAll('.postmodelselection .sub-item-option-panel-disabler', 'is-active');

            const postUrl =
                '/postcolour?dossierId=' +
                dossierId +
                '&featureId=' +
                featureId +
                '&colourId=' +
                colourId +
                '&description=' +
                description +
                '&userSpecifiedDescription=' +
                userSpecifiedDescription +
                '&hexCode=' +
                hexCode +
                '&colourOptionId=' +
                colourOptionId +
                '&colourNatureType=' +
                colourNatureType +
                '&parameter=&parameterValue=&mediatype=json';
            await setColor(postUrl);
            _this.logMessageToKisters(`Selected color option posted to API. ColorId: ${colourId}. Description: ${colorOption.dataset.description}. HexCode: ${hexCode}. ColorOptionId: ${colourOptionId}. ColourNatureType: ${colourNatureType}.`);
        }

        function colourOption(option, colourGroupDescription) {
            const result = _this.createElement('LI', 'sub-item-option');
            result.dataset.optionid = option.Id;

            const item = _this.createElement('A', 'color-option');
            item.dataset.featureid = '';
            item.dataset.colourid = option.Id;
            item.dataset.description = option.Description;
            item.dataset.hexcode = option.HexCode;
            item.dataset.colouroptionid = option.OptionId;
            item.dataset.colournaturetype = option.ColourNatureType;
            item.dataset.configuratorAction = 'configure';
            item.dataset.optionValue = option.Id;
            item.dataset.option = colourGroupDescription;
            item.dataset.optionCategory = colourName;

            item.addEventListener('click', handleColorOptionSelected);

            const colorSelector = _this.createElement('DIV', 'color-selector');
            const optionSelector = _this.createElement('SPAN', 'option-selector');
            const color = _this.createElement('DIV', 'color-color');
            color.style.backgroundColor = `#${option.HexCode}`;
            const colorName = _this.createElement('DIV', 'color-name', option.Id);

            colorSelector.appendChild(optionSelector);
            item.appendChild(colorSelector);
            item.appendChild(color);
            item.appendChild(colorName);
            result.appendChild(item);

            return result;
        }

        function subItem(colourGroup) {
            const result = _this.createElement('LI', 'sidepanel-sub-item');
            const title = _this.createElement('A', 'sidepanel-sub-item-title', colourGroup.Description);
            const optionPanel = _this.createElement('DIV', 'sub-item-option-panel');
            const optionPanelDisabler = _this.createElement('DIV', 'sub-item-option-panel-disabler');
            const optionPanelTitle = _this.createElement('H2', 'sub-item-option-panel-title', colourGroup.Description);
            const options = _this.createElement('UL', 'sub-item-options');

            for (const option of colourGroup.Colours) {
                options.appendChild(colourOption(option, colourGroup.Description));
            }

            optionPanel.appendChild(optionPanelDisabler);
            optionPanel.appendChild(optionPanelTitle);
            optionPanel.appendChild(options);
            result.appendChild(title);
            result.appendChild(optionPanel);

            return result;
        }

        function item(colourGroups) {
            const result = _this.createElement('LI', 'sidepanel-sub-item-colorpicker is-ready is-active');
            const accordionToggleTitle = _this.createElement('A', 'accordion-toggle-title', colourName);
            accordionToggleTitle.dataset.itemname = 'Cab Colour';
            const sidepanelSub = _this.createElement('UL', 'sidepanel-sub sidepanel-sub-colorpicker');

            for (const colourGroup of colourGroups) {
                sidepanelSub.appendChild(subItem(colourGroup));
            }

            result.appendChild(accordionToggleTitle);
            result.appendChild(sidepanelSub);

            return result;
        }

        function buildOptionsMenu(colourGroups) {
            sidePanelMain.insertAdjacentElement('afterbegin', item(colourGroups));
            sidePanels.appendChild(sidePanelMain);
        }

        async function fetchColors() {
            var url = '/GetAvailableColours?dossierId=' + dossierId + '&mediatype=json';
            try {
                const data = await _this._httpClient.get(url);
                buildOptionsMenu(data.ColourGroups);
            } catch (error) {
                console.error(error.message);
                if (error.userFriendlyExceptionMessage) {
                    modal.setModal(true, error.userFriendlyExceptionMessage);
                }
            }
        }

        await fetchColors();
    };

    //Hide the active items so the correct stuff can be shown
    this.cleanup = function () {
        //First the elements that need to animate
        $('.mainpanel').removeClass('is-active');
        $('.main-title').removeClass('is-hidden');
        $('.main-background').removeClass('is-hidden');
        $('.sidepanels').removeClass('is-active');
        $('.postmodelselection .sidepanels .sidepanel-main > li').removeClass('is-ready');
        preventIssuesWhenUsingBrowserBackButton();
        visContainer.classList.remove('is-active', 'is-visible');
        visViewer.classList.remove('is-active', 'is-visible');
        $('.visualisation-controls').removeClass('is-active');
        $('.premodelselectionstep .results-message').removeClass('is-active');
        $('.footer-nav-menu').removeClass('is-active');
        $('.footer-post-model .footer-nav-wrapper').removeClass('is-active');
        $('.footer-post-model .footer-nav .footer-home').removeClass('is-active');
        $('.footer-pre-model').addClass('is-active');
        $('.footer-post-model').removeClass('is-active');
        $('.header-save').removeClass('is-active');
        $('.header-dealerlocator').addClass('is-active');
        $('.header-send').removeClass('is-active');
        $('.button-summary').removeClass('is-active');
        _this.setSwipezone('off');
        _this.setModelName('off');

        //Then actually turn the main elements off
        $('.firststep').removeClass('is-active');
        $('.premodelselectionstep').removeClass('is-active');
        $('.postmodelselection').removeClass('is-active');

        function preventIssuesWhenUsingBrowserBackButton() {
            cleanSidePanel();
            clearFooterNavLinksState();
        }
        function cleanSidePanel() {
            const sidePanelMain = document.querySelector('.sidepanel-main');
            if (sidePanelMain) {
                sidePanelMain.remove();
            }
        }
        function clearFooterNavLinksState() {
            const footerNavLinks = document.querySelectorAll('.footer-nav li');
            for (const link of footerNavLinks) {
                if (link.classList.contains('is-active')) {
                    link.classList.remove('is-active');
                }
            }
        }
    };

    this.goToPreModelStep = function (step) {
        $('.main-title').removeClass('is-hidden');
        $('.main-background').removeClass('is-hidden');
        $('.footer-post-model .footer-nav .footer-home').removeClass('is-active');
        $('.footer-pre-model').addClass('is-active');
        $('.footer-post-model').removeClass('is-active');
        $('.header-save').removeClass('is-active');
        $('.header-dealerlocator').addClass('is-active');
        $('.header-send').removeClass('is-active');
        $('.button-summary').removeClass('is-active');

        _this.cleanup();

        var $footerLi = $('.footer-pre-model .footer-nav li[data-step="' + step + '"]');
        var $footerA = $footerLi.find('a');
        $footerA.trigger('click');
    };

    //Turn on/off the correct navitems and animate the footer background
    this.setFooterNav = function ($a) {
        var $li = $a.parent('li');
        var extraWidth = 1;
        var $footerType = $li.parents('.footer-type');
        var $background = $footerType.find('.active-background');
        var w = $li.outerWidth(true) + extraWidth;
        var offset = $li.offset();
        $background.css('width', w).css('left', offset.left + 'px');
        $li.siblings().removeClass('is-active');
        $li.addClass('is-active');

        _this.setVisualisationControls(true);
        _this.setSwipezone('off');
    };

    this.setVisualisationControls = function (hide) {
        // Hide the truck and controls:
        if (hide) {
            _this.setModelName('off');
            $('.visualisation-controls').removeClass('is-active');
            visContainer.classList.remove('is-active');
            visViewer.classList.remove('is-active');
            return;
            // Make sure truck and controls are visible again:
        } else if (!hide) {
            _this.setModelName('on');
            if (!$('.visualisation-controls').hasClass('is-active')) {
                $('.visualisation-controls').addClass('is-active');
            }
            visContainer.classList.add('is-active');
            visViewer.classList.add('is-active');
            return;
        }
    };

    this.validateShareKey = function () {
        const shareKey = _this.getElementById('ShareKey');
        if (!shareKey) return false;
        return shareKey.value.length > 0;
    };

    this.showSummary = function () {
        if (!_this.validateShareKey()) return;

        const footerSummaryBtn = _this.select('footer .button-summary');

        if (!footerSummaryBtn) return;

        setTimeout(function () {
            footerSummaryBtn.click();
            _this.removeClass('footer', 'is-disabled');
        }, 10);
    };

    this.handleConfigurationLoaded = async function (e) {
        if (Html.select('.loader').classList.contains('is-active')) {
            _this.setLoader('off', 'dark');
        }
        _this._truckRenderLoadingScreen.show();
        const data = e.detail.data;
        _this.cleanup();

        let flow = Html.getById('Flow').value;
        if (flow.length === 0) flow = 'product';

        const otcMain = Html.select('.otc-main');
        otcMain.dataset.dossier = data.DossierId;

        _this._store.configurationData = data;

        await _this.createFooterNav(flow, false);
        await _this.initViewer();

        const postModelSelection = Html.select('.postmodelselection');
        postModelSelection.classList.add('is-active');

        const footerPreModel = Html.select('.footer-pre-model');
        footerPreModel.classList.remove('is-active');

        await _this.showConfiguration();

        window.digitalData.triggerVirtualPageView({
            title: this._settings.pageViewTitle,
            name: 'Configure',
            page: 'configure',
        });
    };

    this.showConfiguration = async function () {
        const sidePanels = _this.select('.postmodelselection .sidepanels');

        if (!sidePanels) return;

        const mainContent = document.getElementById('main-container');
        const extendedOptionDescriptionModal = document.getElementById('extended-option-description-modal');
        const extendedOptionDescriptionModalCloseBtn = document.querySelector('.extended-option-description-modal__close-btn');
        const extendedOptionDescriptionModalLoader = document.querySelector('.extended-option-description-modal__loader');
        let extendedOptionDescriptionTitle = document.querySelector('.extended-option-description-modal__title');
        const extendedOptionDescriptionDetails = document.querySelector('.extended-option-description-modal__details');
        let extendedOptionDescriptionImage = document.querySelector('.extended-option-description-modal__img');
        let extendedOptionDescriptionText = document.querySelector('.extended-option-description-modal__description');
        const extendedOptionDescriptionUspTitle = document.querySelector('.extended-option-description-modal__usp-title');
        const extendedOptionDescriptionUspList = document.querySelector('.extended-option-description-modal__usp-list');

        const sidePanelMain = _this.createElement('UL', 'sidepanel-main');
        const featureGroups = _this._store.configurationData?.FeatureGroups;
        const noDescriptionText = sidePanels.dataset.nodescriptiontext;
        const colourName = sidePanels.dataset.colourname;

        _this.removeClass('.detail-main', 'is-active');
        _this.addClass('.postmodelselection', 'is-active');

        function cleanupPreviousElements() {
            _this.addClass('.main-background', 'is-hidden');
            _this.removeClass('.detail-maincontent', 'is-active');
            _this.removeClassFromAll('.premodelselectionstep', 'is-active');
            _this.removeClassFromAll('.premodelselectionstep-results', 'is-active');
            _this.removeClassFromAll('.premodelselectionstep .mainpanel', 'is-active');
            _this.removeClassFromAll('.premodelselectionstep .sidepanels', 'is-active');
            _this.addClassToAll('.main-title', 'is-hidden');

            const breadcrumb = _this.getElementById('breadcrumb');
            if (breadcrumb) breadcrumb.innerHTML = '';

            _this.addClass('.header-save', 'is-active');
            _this.removeClass('.header-dealerlocator', 'is-active');
            _this.addClass('.header-send', 'is-active');
            _this.addClass('.button-summary', 'is-active');
        }

        cleanupPreviousElements();

        let selectedMoreInfoBtn;

        async function subItemOption(option, featureId, category) {
            const result = _this.createElement('LI', 'sub-item-option');
            result.dataset.optionid = option.Id;
            result.dataset.descriptionid = option.ExtendedDescriptionId;
            if (option.IsSelected === true) {
                result.classList.add('is-selected');
            }
            if (option.IsIncompatible === true) {
                result.classList.add('is-incompatible');
            }
            const header = _this.createElement('DIV', 'option-header');
            const item = _this.createElement('DIV', 'option-item');
            item.dataset.featureid = featureId;
            item.dataset.optionid = option.Id;
            item.dataset.configuratorAction = 'configure';
            item.dataset.optionValue = option.Description;
            item.dataset.option = option.Description;
            item.dataset.optionCategory = category;
            const selector = _this.createElement('A', 'option-selector');
            const title = _this.createElement('A', 'option-title');
            title.dataset.featureid = featureId;
            title.dataset.optionid = option.Id;
            const titleText = _this.createElement('SPAN', 'option-title-text', option.Description);
            const description = _this.createElement('p', 'option-description');
            description.dataset.nodescriptiontext = noDescriptionText;
            title.appendChild(titleText);
            item.appendChild(selector);
            item.appendChild(title);
            header.appendChild(item);
            if (option.ExtendedDescriptionId !== null) {
                item.dataset.descriptionid = option.ExtendedDescriptionId;
                title.dataset.descriptionid = option.ExtendedDescriptionId;
                const moreInfoBtn = _this.createElement('BUTTON', 'option-more-info-btn', 'i');
                moreInfoBtn.addEventListener('click', (event) => {
                    selectedMoreInfoBtn = event.target;
                    showExtendedOptionDescriptionModal(option.ExtendedDescriptionId, option.Id, option.Description);
                });
                header.appendChild(moreInfoBtn);
            }
            result.appendChild(header);
            result.appendChild(description);
            return result;
        }

        async function showExtendedOptionDescriptionModal(descriptionId, optionId, optionTitle) {
            extendedOptionDescriptionModal.setAttribute('aria-label', optionTitle);
            extendedOptionDescriptionModal.showModal();
            mainContent.setAttribute('inert', '');

            extendedOptionDescriptionTitle.innerText = optionTitle;
            extendedOptionDescriptionModalLoader.classList.remove('invisible');

            const url = `/getoptiondescription?extendedDescriptionId=${descriptionId}&optionId=${optionId}&languageId=${_this._settings.languageId}&marketId=${_this._settings.marketId}&commercialSpecId=${_this._store.selectedCommercialSpecId}&mediatype=json`;
            try {
                const response = await _this._httpClient.get(url);
                extendedOptionDescriptionModalLoader.classList.add('invisible');
                extendedOptionDescriptionDetails.classList.remove('invisible');

                if (response.ImageUrls.length > 0) {
                    extendedOptionDescriptionImage.src = response.ImageUrls[0];
                }

                extendedOptionDescriptionText.innerText = response.ExtendedDescription;

                if (response.SalesArgumentationDescriptions && response.SalesArgumentationDescriptions.length > 0) {
                    extendedOptionDescriptionUspTitle.classList.remove('no-display');

                    for (const usp of response.SalesArgumentationDescriptions) {
                        const uspElem = document.createElement('LI');
                        uspElem.innerText = usp;
                        extendedOptionDescriptionUspList.appendChild(uspElem);
                    }
                }
            } catch (error) {
                console.error(error.message);
                if (error.userFriendlyExceptionMessage) {
                    modal.setModal(true, error.userFriendlyExceptionMessage);
                }
            }
        }

        extendedOptionDescriptionModalCloseBtn.addEventListener('click', () => {
            extendedOptionDescriptionModal.setAttribute('aria-label', '');
            extendedOptionDescriptionTitle.innerText = '';
            extendedOptionDescriptionImage.src = '';
            extendedOptionDescriptionText.innerText = '';

            for (const usp of Array.from(extendedOptionDescriptionUspList.children)) {
                usp.remove();
            }

            extendedOptionDescriptionDetails.classList.add('invisible');
            extendedOptionDescriptionUspTitle.classList.add('no-display');
            extendedOptionDescriptionModal.close();
        });

        extendedOptionDescriptionModal.addEventListener('close', () => {
            mainContent.removeAttribute('inert');
            selectedMoreInfoBtn.focus();
        });

        async function subItem(feature, featureDescription) {
            const result = _this.createElement('LI', 'sidepanel-sub-item');
            const title = _this.createElement('A', 'sidepanel-sub-item-title', feature.Description);
            const optionPanel = _this.createElement('DIV', 'sub-item-option-panel');
            const optionPanelDisabler = _this.createElement('DIV', 'sub-item-option-panel-disabler');
            const optionPanelTitle = _this.createElement('H2', 'sub-item-option-panel-title', feature.Description);
            const options = _this.createElement('UL', 'sub-item-options');

            for (const option of feature.Options) {
                options.appendChild(await subItemOption(option, feature.Id, featureDescription));
            }
            optionPanel.appendChild(optionPanelDisabler);
            optionPanel.appendChild(optionPanelTitle);
            optionPanel.appendChild(options);
            result.appendChild(title);
            result.appendChild(optionPanel);

            return result;
        }

        async function item(featureGroup) {
            const result = _this.createElement('LI', 'sidepanel-item is-ready');
            result.dataset.featuregroup = featureGroup.Id;
            const accordionToggleTitle = _this.createElement('A', 'accordion-toggle-title', featureGroup.Description);
            const sidepanelSub = _this.createElement('UL', 'sidepanel-sub');

            for (const feature of featureGroup.Features) {
                sidepanelSub.appendChild(await subItem(feature, featureGroup.Description));
            }

            result.appendChild(accordionToggleTitle);
            result.appendChild(sidepanelSub);

            return result;
        }

        for (const featureGroup of featureGroups) {
            sidePanelMain.appendChild(await item(featureGroup));
        }

        _this.removeClass('.footer-pre-model', 'is-active');
        _this.addClass('.footer-post-model', 'is-active');
        _this.addClass('footer', 'is-active');

        _this.setSidePanelHeight('postmodelselection');
        await _this.initColorPicker(sidePanels, sidePanelMain, colourName);
    };

    this.initValidationMessage = function () {
        $('.btn-validation-apply').on('click', function () {
            _this.logMessageToKisters('User applied selected configuration option by approving selection in modal.');
            //It's actually already applied, so we don't need to do anything except close the modal
            $('.modal-validation .modal-close').trigger('click');
        });

        $('.btn-validation-cancel').on('click', function () {
            $('.modal-validation').addClass('is-canceled');
            //We need to reset the selected option (so trigger the previous option)
            $(
                '.sidepanel-main .sub-item-options li[data-optionid="' +
                    $('.modal-validation').attr('data-previous-optionid') +
                    '"] .option-item',
            ).trigger('click');
            //And close the modal
            $('.modal-validation .modal-close').trigger('click');
        });
    };

    this.initSendToDealerValidationMessage = () => {
        const $form = document.getElementById('form');
        const $validationFields = $form.getElementsByClassName('validation-required');
        const $inputFields = $form.getElementsByClassName('input-code');
        const $closeButton = document.querySelector('.modal-save .modal-close');
        const $successMessage = document.querySelector('.alert-success');
        const waitTime = 500;
        let timer = null;

        $form.addEventListener('submit', async (event) => {
            event.preventDefault();

            for (let i = 0; i < $validationFields.length; ++i) {
                this.setValidationMessage($validationFields[i]);
            }

            try {
                await _this._httpClient.post('/shareconfigurationthroughemail', {
                    itemId: _this._settings.itemId,
                    dossierId: $('.otc-main').attr('data-dossier'),
                    recipientName: $('#form #recipientName').val(),
                    recipientEmail: $('#form #recipientEmail').val(),
                    senderName: $('#form #senderName').val(),
                    senderEmail: $('#form #senderEmail').val(),
                    message: $('#form #message').val(),
                });

                $closeButton.click();
                $successMessage.classList.remove('fade');

                setTimeout(() => {
                    $successMessage.classList.add('fade');
                }, 5000);
            } catch (error) {
                console.error(error.message);
                if (error.userFriendlyExceptionMessage) {
                    modal.setModal(true, error.userFriendlyExceptionMessage);
                }
            }
        });

        $closeButton.addEventListener('click', () => {
            for (let i = 0; i < $inputFields.length; ++i) {
                $inputFields[i].value = '';
            }

            for (let i = 0; i < $validationFields.length; ++i) {
                this.clearValidationMessage($validationFields[i]);
            }
        });

        for (let i = 0; i < $validationFields.length; ++i) {
            $validationFields[i].addEventListener('keyup', () => {
                clearTimeout(timer);

                timer = setTimeout(() => {
                    this.setValidationMessage($validationFields[i]);
                }, waitTime);
            });
        }
    };

    this.setValidationMessage = (validationField) => {
        const nameRegExp = /.*\S.*/;
        const emailRegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        const messageMaxLength = 500;

        const recipientName = document.getElementById('form').querySelector('#recipientName').id;
        const recipientEmail = document.getElementById('form').querySelector('#recipientEmail').id;
        const senderName = document.getElementById('form').querySelector('#senderName').id;
        const senderEmail = document.getElementById('form').querySelector('#senderEmail').id;

        const message = document.getElementById('form').querySelector('#message').id;
        let isValid = true;

        if (validationField.id === recipientName || validationField.id === senderName) {
            isValid = !this.isEmpty(validationField.value) && nameRegExp.test(validationField.value);
        } else if (validationField.id === recipientEmail || validationField.id === senderEmail) {
            isValid = !this.isEmpty(validationField.value) && emailRegExp.test(validationField.value);
        } else if (validationField.id === message) {
            isValid = validationField.value.length <= messageMaxLength;
        } else {
            isValid = this.isEmpty(validationField.value) || emailRegExp.test(validationField.value);
        }

        validationField.classList.toggle('invalid', !isValid);
        validationField.nextElementSibling.classList.toggle('hidden', isValid);
    };

    this.clearValidationMessage = (field) => {
        field.classList.remove('invalid');
        field.nextElementSibling.classList.add('hidden');
    };

    this.isEmpty = (str) => {
        return !str.replace(/^\s+/g, '').length;
    };

    this.initViewer = async function () {
        //Fallback / error handling (just using a time for now)
        var fallbackTimer = 0;
        var fallbackTrigger = $('#viewerErrorMessageSeconds').val();
        var fallbackInterval = setInterval(function () {
            fallbackTimer++;
            if (fallbackTimer == fallbackTrigger) {
                modal.setModal(true, $('.modal').attr('data-apierrortext'));
            }
        }, 1000);

        _this._store.fallbackInterval = fallbackInterval;
        await _this.onInitializedViewer(_this.client);
        visContainer.classList.add('is-active');
        visViewer.classList.add('is-active');
        const shareWithDealerBtnMobile = Html.getById('share-with-dealer-btn-mobile');
        shareWithDealerBtnMobile.classList.add('is-active');
    };

    this.onInitializedViewer = async function (client) {
        _this.viewerActions(client);
        const dossierId = $('.otc-main').attr('data-dossier');
        const url = '/postclientauthenticated?dossierId=' + dossierId + '&mediatype=json';

        try {
            await _this._httpClient.post(url);
            //The truck should now be shown
            clearInterval(_this._store.fallbackInterval);

            var resizeTimer;

            $(window).on('resize', function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function () {
                    if (_this.client) {
                        // var viewerElement = $('.visualisationviewer');
                        _this.client.resize($visViewer.width(), $visViewer.height());
                    }
                }, 500);
            });
        } catch (error) {
            console.error(error.message);
            if (error.userFriendlyExceptionMessage) {
                modal.setModal(true, error.userFriendlyExceptionMessage);
            }
        }
    };

    this.viewerActions = function (client) {
        const disclaimerBtn = document.querySelector('.visualisation-controls .btn-disclaimer');
        const disclaimerBtnMobile = document.querySelector('.btn-disclaimer-mobile');

        disclaimerBtn?.addEventListener('click', showDisclaimerModal);
        disclaimerBtnMobile?.addEventListener('click', showDisclaimerModal);

        function showDisclaimerModal() {
            modal.setModal(true, false, 'disclaimer');
            const disclaimerModal = document.querySelector('.modal-disclaimer');
            _this.updateModalContentToggle(disclaimerModal);
        }

        const controlsTurn = document.querySelector('.visualisation-controls .controls-turn');
        const controlsViewLinks = document.querySelectorAll('.visualisation-controls .controls-view a');

        initViewerControls();

        function initViewerControls() {
            initTopView();
            init360View();
            initTurnControls();
        }

        function initTopView() {
            const controlTop = document.querySelector('.visualisation-controls .control-top');
            controlTop?.addEventListener('click', (e) => activateControl(e, 'Top'));
        }

        function init360View() {
            const controlFront = document.querySelector('.visualisation-controls .control-front');
            controlFront?.addEventListener('click', (e) => activateControl(e, 'Isometric'));
        }

        function initTurnControls() {
            const turnControlElements = document.querySelectorAll('.visualisation-controls .control-turn');
            for (const control of turnControlElements) {
                control.addEventListener('click', rotate);
            }
        }

        function activateControl(event, alignment) {
            controlsTurn.dataset.alignment = alignment;
            if (alignment === 'Top') {
                controlsTurn.classList.remove('is-active');
            } else {
                controlsTurn.classList.add('is-active');
            }
            for (const control of controlsViewLinks) {
                control.classList.remove('is-active');
            }
            const clickedControl = event.target.closest(`.control-${alignment === 'Top' ? 'top' : 'front'}`);
            clickedControl.classList.add('is-active');
            setPointOfView(alignment);
        }

        function setPointOfView(alignment) {
            const xml =
                '<Call Method="PauseRendering"></Call>' +
                `<Call Method="AlignView"><Alignment>${alignment}</Alignment></Call>` +
                '<Call Method="ResetZoom"></Call>' +
                '<Call Method="ResumeRendering"></Call>';
            client.command.executeXML(xml);
        }

        function rotate(e) {
            const controlElement = e.target.closest('.control-turn');
            const direction = controlElement.dataset.direction;
            const turnStep = 10;
            let hAngle;
            const r = controlsTurn.dataset.rotation;
            controlsTurn.classList.add('is-active');

            if (direction === 'left') {
                hAngle = parseInt(r) - turnStep;
            } else {
                hAngle = parseInt(r) + turnStep;
            }

            if (hAngle > 360) hAngle = 10;
            if (hAngle < 0) hAngle = 350;

            controlsTurn.dataset.rotation = hAngle;

            const xml =
                '<Call Method="PauseRendering"></Call>' +
                '<Call Method="AlignView"><Alignment>Isometric</Alignment></Call>' +
                `<Call Method="SetSceneSettings"><Settings><Scene><Alignment><HAngle>${hAngle}</HAngle><VAngle>1</VAngle><UpVector>Z</UpVector></Alignment></Scene></Settings></Call>` +
                '<Call Method="AlignView"><Alignment>Isometric</Alignment></Call>' +
                '<Call Method="ResetZoom"></Call>' +
                '<Call Method="ResumeRendering"></Call>';
            client.command.executeXML(xml);
        }
    };

    return this;
};

// credit: http://www.javascriptkit.com/javatutors/touchevents2.shtml
function swipedetect(el, callback) {
    var touchsurface = el,
        swipedir,
        startX,
        startY,
        distX,
        distY,
        threshold = 150, //required min distance traveled to be considered swipe
        restraint = 100, // maximum distance allowed at the same time in perpendicular direction
        allowedTime = 300, // maximum time allowed to travel that distance
        elapsedTime,
        startTime,
        handleswipe = callback || function () {};

    touchsurface.addEventListener(
        'touchstart',
        function (e) {
            var touchobj = e.changedTouches[0];
            swipedir = 'none';
            //dist = 0;
            startX = touchobj.pageX;
            startY = touchobj.pageY;
            startTime = new Date().getTime(); // record time when finger first makes contact with surface
            e.preventDefault();
        },
        false,
    );

    touchsurface.addEventListener(
        'touchmove',
        function (e) {
            e.preventDefault(); // prevent scrolling when inside DIV
        },
        false,
    );

    touchsurface.addEventListener(
        'touchend',
        function (e) {
            var touchobj = e.changedTouches[0];
            distX = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
            distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
            elapsedTime = new Date().getTime() - startTime; // get time elapsed
            if (elapsedTime <= allowedTime) {
                // first condition for awipe met
                if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
                    // 2nd condition for horizontal swipe met
                    swipedir = distX < 0 ? 'left' : 'right'; // if dist traveled is negative, it indicates left swipe
                } else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) {
                    // 2nd condition for vertical swipe met
                    swipedir = distY < 0 ? 'up' : 'down'; // if dist traveled is negative, it indicates up swipe
                }
            }
            handleswipe(swipedir);
            e.preventDefault();
        },
        false,
    );
}

// add data-attribute to body element on local environment
// used by _breakpoint-indicator.scss
const addLocalEnvAttributeToBody = () => {
    if (document.location.href.indexOf('daf.local') > 0) {
        document.body.setAttribute('data-is-local-env', true);
    }
};

// register to Component Handler
window.ComponentHandler.register({
    constructor: otcMain,
    classAsString: 'otcMain',
    cssClass: 'js-truckconfigurator',
});
addLocalEnvAttributeToBody();

export { otcMain as TruckConfigurator };
